import { tokenStorage } from '@/features/auth/utils/tokenStorage';

export type AuthHeadersOptions = {
    withMfaToken?: boolean;
    withLocation?: boolean;
};

export function buildCommonHeaders(
    options: AuthHeadersOptions = {}
): Record<string, string> {
    const headers: Record<string, string> = {};

    const accessToken = tokenStorage.getAccessTokenOptional();
    if (accessToken) {
        headers.Authorization = `Bearer ${accessToken}`;
    }

    const firebaseToken = tokenStorage.getFirebaseTokenOptional();
    if (firebaseToken) {
        headers['x-firebase-session'] = firebaseToken;
    }


    if (options.withMfaToken) {
        try {
            headers['x-mfa-token'] = tokenStorage.getMfaToken();
        } catch (error) {
            // Silently skip if MFA token is not available
        }
    }

    if (options.withLocation) {
        try {
            const location = tokenStorage.getLocation();
            headers['x-location-lat'] = String(location.lat);
            headers['x-location-lng'] = String(location.lng);
        } catch (error) {
            // Silently skip if location is not available
        }
    }

    return headers;
};
